<script>
  let { label, name, value, checked = $bindable(false), ...props } = $props()
</script>

<label for={name} class="inline-flex items-center gap-2 cursor-pointer checkbox-label">
  <input type="checkbox" {name} {value} id={name} bind:checked class="w-4 h-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500" {...props} />
  <span class="text-nowrap text-sm text-gray-600">{label}</span>
</label>
